export const messaging = [
  {
    title: true,
    name: 'Settings',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  },
  {
    name: 'App List',
    url: '/messaging/applist',
    icon: 'icon-list'
  },
  {
    name: 'Create App',
    url: '/messaging/createapp',
    icon: 'icon-plus'
  },
  {
    name: 'API Key',
    url: '/messaging/apikey',
    icon: 'icon-key'
  },
  {
    name: 'History',
    url: '/messaging/history',
    icon: 'fa fa-history'
  },
  {
    name: 'User Token',
    url: '/messaging/usertoken',
    icon: 'fa fa-certificate'
  },
  {
    name: 'Send Notification',
    url: '/messaging/sendnotification',
    icon: 'fa fa-paper-plane'
  }
];
